import { unwrap } from './client';
import api from './client';

export const listAdminTenants = () => unwrap(api.get('/admin/tenants'));
export const createAdminTenant = (payload) => unwrap(api.post('/admin/tenants', payload));
export const updateAdminTenant = (id, payload) => unwrap(api.patch(`/admin/tenants/${id}`, payload));

export const listAdminUsers = (tenantId) =>
  unwrap(api.get('/admin/users', { params: tenantId ? { tenant_id: tenantId } : {} }));
export const createAdminUser = (payload) => unwrap(api.post('/admin/users', payload));
export const updateAdminUser = (id, payload) => unwrap(api.patch(`/admin/users/${id}`, payload));
export const deleteAdminUser = (id) => unwrap(api.delete(`/admin/users/${id}`));

export const listAdminRoles = () => unwrap(api.get('/admin/roles'));
export const updateAdminRole = (id, payload) => unwrap(api.patch(`/admin/roles/${id}`, payload));

export const listAdminModules = () => unwrap(api.get('/admin/modules'));
